const InputBox = ({
    title,
    value,
    placeholder = null,
    size,
    password,
    number,
    autoComplete,
    onChange = () => {},
    onKeyDown = () => {},
    disabled = false,
    maxLength,
    min,
    max,
}) => {
    return (
        <div
            // className={'form-box'}
            className={
                'form-box' +
                (size != undefined
                    ? size == 'small'
                        ? ' w-sm'
                        : size == 'medium'
                        ? ' w-md'
                        : size == 'w-420'
                        ? ' w-420'
                        : ' w-lg'
                    : '')
            }
        >
            <div className='input-box'>
                <label htmlFor={title}>{title}</label>
                <div className='input-group'>
                    <input
                        id={title}
                        type={password ? 'password' : number ? 'number' : 'text'}
                        className='form-control'
                        disabled={disabled}
                        value={value == undefined || value == null ? '' : value}
                        placeholder={placeholder}
                        onChange={(e) => onChange(e)}
                        onKeyDown={(e) => onKeyDown(e)}
                        autoComplete={autoComplete ? 'on' : 'off'}
                        maxLength={maxLength && maxLength}
                        min={min && min}
                        max={max && max}
                    />
                </div>
            </div>
        </div>
    );
};

export default InputBox;
